$('.top-banner').on('click', function() {
    var screensize = document.documentElement.clientWidth;
    if (screensize  < 1200) {
        $(this).toggleClass('active');
        $(this).find('.top-banner__button').toggleClass('active');
        $(this).find('.top-banner__text').slideToggle();
    }
});

$( window ).resize(function() {
    var screensize = document.documentElement.clientWidth;
    if (screensize  > 1200) {
        $('.top-banner').removeClass('active');
        $('.top-banner__button').removeClass('active');
        $('.top-banner__text--mobile').hide();
        $('.top-banner__text:not(.top-banner__text--mobile)').show();
    }
});

// $( document ).ready(function() {
    // $('h2').each(function () {
    //     var element = $(this);
    //     element.text(element.text().replace(/Hi|welvaartsevangelie|Hey/g, "Bye"));
    // });
// });

$('.featured-preek__image__content__buttons__index').on('click', function() {
    var index = $(this).attr('data-index');
    window.location.href = index;
    return false;
});
  